import React, { useEffect, useRef } from 'react';
import { useStats } from 'react-instantsearch';

interface CustomStatsProps {
  setNbItems: (nbItems: number) => void;
  nbItems: number;
}

export const CustomStats = ({ setNbItems, nbItems }: CustomStatsProps) => {
  const { nbHits } = useStats();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current && nbHits === nbItems) return;
    setNbItems(nbHits);
  }, [nbHits]);

  return <></>;
};
